export default __webpack_public_path__ + "static/media/spiderman.ea132bd8.jpg";